export default __webpack_public_path__ + "media/images/ui-bg_glass_75_dadada_1x400-f10a359f3e144122592fb158abd3bf97.png";